export default {
  getchangeLostDialog (state) {
    return state.changeLostDialog
  },
  getShowFullLoader (state) {
    return state.showFullLoader
  },
  listOfModules (stateObj) {
    return stateObj.listOfModules
  }
}
